import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ConfigService} from './core/config/config.service';
import {TranslateService} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatButtonModule],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {

  private readonly config = inject(ConfigService);
  private readonly translate = inject(TranslateService);

  footerText: string;

  constructor() {
    // We need to do the setup here, and not in the config service.
    // We cannot inject the TranslateService into the ConfigService, since the ConfigService is
    //    provided in root, and the TranslateService is not.
    this.translate.addLangs(['en-ZA', 'af-ZA']);

    this.config.navigate();
    this.translate.use(this.config.language);
    this.footerText = this.config.footerText;
  }

}
